<template>
  <custom-dialog
    width="800px"
    :append-to-body="true"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    class="slot-list-dialog"
  >
    <div class="dialog-body">
      <div class="device-list">
        <div
          class="device-item"
          v-for="(item,index) in listData"
          :key="index"
          :class="{conflict: item.conflict}"
        >
          <div class="tips-top">
            <div class="title">{{item.tips}}</div>
            <i
              @click="onEditRouteName(item)"
              class="icon icon-bianji"
              v-if="item.hasRoute && !item.conflict && funcView.route_edit"
            ></i>
            <i
              @click="onDel(item)"
              class="icon icon-shanchu"
              v-if="item.hasRoute && !item.conflict && funcView.route_del"
            ></i>
            <i
              @click="onTranslate(item)"
              class="icon icon-conflict"
              v-if="item.conflict && funcView.route_translate"
            ></i>
          </div>
          <div
            :src="item.productIcon"
            alt=""
            class="img"
            v-if="item.hasRoute"
          >
            <el-image
              style="width: 100%; height: 100%;"
              :src="item.productIcon"
              :preview-src-list="[item.productIcon]"
            >
            </el-image>
          </div>
          <div
            class="map-mode"
            v-if="item.hasRoute && item.mapMode"
          >{{getDicValue('iot_tsl_map_mode', item.mapMode)}}</div>
          <div
            class="tips-bottom"
            v-if="item.hasRoute"
          >{{momentAmPm($getRouteTime(item))}}</div>
        </div>
      </div>
    </div>
    <div
      class="dialog-foote"
      slot="footer"
    >
      <el-button
        type="primary"
        @click="onConfirm"
      >{{$t('Common.com_confirm')}}</el-button>
    </div>
    <edit-route-name-dialog
      v-if="editRouteNameVisible"
      @close="editRouteNameVisible = false"
      :model="editRouteNameModel"
      @success="getTableList"
    ></edit-route-name-dialog>
    <translate-slot-dialog
      v-if="translateSlotVisible"
      @close="onCloseSuccess"
      :model="translateSlotModel"
      @success="getTableList"
      @del="onDelSuccess"
    ></translate-slot-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import editRouteNameDialog from './edit_route_name_dialog.vue';
import translateSlotDialog from './translate_slot_dialog.vue';

export default {
  name: 'slotListDialog',
  mixins: [dialogMixins],
  components: {
    editRouteNameDialog,
    translateSlotDialog
  },
  props: {
  },
  data() {
    return {
      list: [],
      listData: [],
      editRouteNameVisible: false,
      editRouteNameModel: {},
      // 转存操作dialog
      translateSlotVisible: false,
      translateSlotModel: {},
      updateStack: [],
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    onDelSuccess() {
      this.updateStack.push(1);
    },
    onCloseSuccess() {
      this.translateSlotVisible = false;
      if (this.updateStack.length) {
        this.updateStack = [];
        this.getTableList();
      }
    },
    // 转存 定位码/项目名称/区域名称/路线槽
    onTranslate(data) {
      const char = data.char;
      const row = data.data[0];
      const {
        hlcCode, locationName, siteName
      } = row;
      const title = [hlcCode, locationName, siteName, char].join('/');

      this.translateSlotModel = {
        title,
        data: row
      };
      this.translateSlotVisible = true;
    },
    onEditRouteName(data) {
      const row = data.data[0];
      this.editRouteNameModel = {
        data: row
      };

      this.editRouteNameVisible = true;
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.closeDialog();
    },
    formatList(list) {
      const charArr = 'A B C D E F';
      const listData = charArr.split(' ').map(char => ({
        char,
        data: [],
      }));

      // 将list按slotCode进行分组
      list.forEach((item) => {
        const curSlotCode = item.slotCode;
        const pNode = listData.find(obj => obj.char === curSlotCode);
        if (pNode) {
          pNode.data.push(item);
        }
      });

      listData.forEach((item) => {
        // 格式化是否有路线，是否冲突
        if (!item.data.length) {
          item.hasRoute = false;
        } else {
          item.hasRoute = true;
          if (item.data.length > 1) {
            item.conflict = true;
          }
        }

        if (item.data.length) {
          const obj = item.data[item.data.length - 1];

          item.gmtCreate = obj.gmtCreate;
          item.mapCreateTime = obj.mapCreateTime;
          item.modemRecordTime = obj.modemRecordTime;

          item.mapMode = obj.mapMode;
        }

        const arr = [item.char];
        // 格式化小标题
        if (item.data.length) {
          const info = item.data[item.data.length - 1];
          if (info.mapName) {
            arr.push(`(${info.mapName})`);
          }
        }
        item.tips = arr.join(' ');

        // 获取图片
        if (item.data.length) {
          const info = item.data[item.data.length - 1];
          if (info.mapId) {
            const data = {
              bizId: info.mapId,
              bizType: 'i'
            };
            this.$getFileList(data).then((fileList) => {
              if (fileList && fileList.length) {
                const curIndex = this.listData.findIndex(obj => obj.char === item.char);
                const file = fileList[0];
                if (curIndex >= 0) {
                  const slotItem = this.listData[curIndex];
                  this.$set(slotItem, 'productIcon', file.attachPath || file.url);
                }
              }
            });
          }
        }
      });

      return listData;
    },
    getTableList() {
      const { productCode, siteId, hlcCode } = this.model.data;
      const reqUrl = `${apis.hlcSlotAppSoltList}/${productCode}/${siteId}/${hlcCode}`;
      this.$getJSON(reqUrl).then((res) => {
        if (!res.data) {
          res.data = [];
        }
        const list = res.data;
        const listData = this.formatList(list);
        this.list = list;
        this.listData = listData;
      });
    },
    async onDel(data) {
      const row = data.data[0];
      const { slotCode, mapName } = row;
      // const slotCodeName = this.dicMap.sbr_slot[slotCode];
      // 所选路线的槽号+路线名称
      const subStr = [slotCode, mapName].filter(val => !!val).join('/');
      const tips = this.$t('dms_slot_list_dialog.nqdysclxom', [subStr]);
      await this.$showConfirm(tips);
      const reqUrl = `${apis.hlcSlotDelete}/${row.hlcSlotId}`;
      await this.$postJSON(reqUrl);
      this.$message({
        message: this.$t('Common.com_delete_success'),
        type: 'success'
      });
      this.getTableList();
    },
  },
  created() {
  },
  mounted() {
    this.getFuncView();
    this.getDicMap('sbr_slot,hlc_slot_state', () => {
      this.getTableList();
    });

  },
};
</script>

<style lang="scss">
.slot-list-dialog {
  .device-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: flex-start;
    padding: 16px;

    .conflict {
      .tips-top {
        background: rgba(255, 173, 0, 0.9) !important;
        .title {
          color: #202945 !important;
        }
      }
    }
    .device-item {
      background: #fff;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
      margin-bottom: 16px;
      position: relative;
      border-radius: 2px;
      width: 200px;
      height: 150px;

      .img {
        position: absolute;
        z-index: 0;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        width: 100%;
        height: 100%;
      }

      .tips-top {
        $h: 32px;
        height: $h;
        line-height: $h;
        font-size: 15px;
        background: rgba(77, 77, 77, 0.9);
        position: absolute;
        left: 0;
        width: 100%;
        z-index: 10;
        text-align: left;
        top: 0;
        padding: 0 8px;

        .title {
          float: left;
          line-height: $h;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #fff;
          max-width: 80%;
        }

        .icon {
          cursor: pointer;
        }

        .icon-bianji,
        .icon-shanchu {
          float: right;
          font-size: 12px;
          line-height: $h;
          color: #00a0d9;
        }

        .icon-shanchu {
          margin-right: 10px;
          font-size: 14px;
        }

        .icon-conflict {
          float: right;
          font-size: 12px;
          line-height: $h;
          color: #202945;
        }
      }
      .map-mode {
        $h: 26px;
        height: $h;
        line-height: $h;
        font-size: 14px;
        padding: 0 10px;
        position: absolute;
        right: 0;
        top: 32px;
        z-index: 10;
        background: rgba(248, 248, 248, 0.9);
        color: #4d4d4d;
      }
      .tips-bottom {
        $h: 26px;
        height: $h;
        line-height: $h;
        font-size: 14px;
        text-align: center;
        position: absolute;
        left: 0;
        width: 100%;
        z-index: 10;
        bottom: 0;
        background: rgba(248, 248, 248, 0.9);
        color: #4d4d4d;
      }
    }
  }
}
</style>
